import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { useScale } from '../../../hooks/useScale';

const DocketContinueStyles = () => {
  const { scale } = useScale();
  return useMemo(
    () =>
      StyleSheet.create({
        container: {
          backgroundColor: theme.colors.primaryDark,
          height: scale(38),
          borderRadius: theme.radius.s,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingHorizontal: scale(16),
          marginVertical: scale(4),
        },
        accentBar: {
          position: 'absolute',
          left: scale(6),
          top: scale(6),
          bottom: scale(6),
          width: scale(4),
          height: scale(26),
          backgroundColor: theme.colors.transparent20,
          borderRadius: scale(2),
        },
        orderNumberContainer: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        orderNumberText: {
          fontSize: scale(14),
          lineHeight: scale(22),
          color: theme.colors.white,
          fontFamily: theme.fonts.medium,
        },
        positionText: {
          fontSize: scale(16),
          lineHeight: scale(22),
          color: theme.colors.white,
          fontFamily: theme.fonts.medium,
        },
      }),
    [scale],
  );
};

export default DocketContinueStyles;
